import { theme } from '@chakra-ui/react';

export default {
  baseStyle: {
    ...theme.components.Link.baseStyle,
    color: 'blue.500',
  },
};
